function addVisibility(div, id) {
    const item = div.querySelector(`[data-id="${id}"]`);
    item.classList.add('active');
}

function removeVisibility(div, id) {
    const item = div.querySelector(`[data-id="${id}"]`);
    item.classList.remove('active');
}

function init() {
    const dropdown = document.querySelector('.dropdown-nav');
    if (dropdown) {
        const items = dropdown.querySelectorAll('.dropdown-nav__link');
        const icons = document.querySelector('.nav-icons');

        items.forEach((item) => {
            item.addEventListener('mouseenter', () => {
                addVisibility(icons, item.dataset.id);
            });
            item.addEventListener('mouseleave', () => {
                removeVisibility(icons, item.dataset.id);
            });
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    init();
});
